
import { i18nText } from '@/locales';
import { RouterNameEnum } from '@/router/router.types';
export const ReportRoutes = [
    {
        path: '/reports',
        redirect: '/reports/index',
        component: (): any => import('../../UI/layouts/MainLayout.vue'),
        meta: {
            auth: true,
        },
        children: [
            {
                path: '/reports/index',
                meta: {
                    breadcrumb: [{ name: i18nText("Отчеты") }],
                },
                name: RouterNameEnum.Reports,
                component: (): any => import('../../UI/pages/reports/Pages/Reports.vue'),
            },
            {
                path: '/reports/sales_target',
                meta: {
                    breadcrumb: [{ name: i18nText("План продаж") }],
                },
                name: RouterNameEnum.SalesTarget,
                component: (): any => import('../../UI/pages/reports/Pages/SalesTarget.vue'),
            },
            {
                path: '/reports/be_employee',
                meta: {
                    breadcrumb: [{ name: i18nText("По сотрудникам") }],
                },
                name: RouterNameEnum.BeEmployee,
                component: (): any => import('../../UI/pages/reports/Pages/ByEmployee.vue'),
            },
            {
                path: '/reports/be_employee_dynamics',
                meta: {
                    breadcrumb: [{ name: i18nText("По сотрудникам в динамике") }],
                },
                name: RouterNameEnum.BeEmployeeDynamics,
                component: (): any => import('../../UI/pages/reports/Pages/ByEmployeeDynamics.vue'),
            },
            {
                path: '/reports/sales_by_service/:Studio',
                meta: {
                    alias: RouterNameEnum.SalesByService,
                    breadcrumb: [{ name: i18nText("Продажи по услугам") }],
                    props: {
                        source: {
                            root: "Report",
                            name: "Report",
                            items: "reports",
                            item: "report",
                            routePage: RouterNameEnum.SalesByServicePage,
                        },
                    },
                },
                name: RouterNameEnum.SalesByService,
                component: (): any => import('../../UI/pages/reports/Pages/SalesByService.vue'),
            },
            {
                path: '/reports/sales_by_service/:Studio/page/:page/:total/:filter',
                meta: {
                    alias: RouterNameEnum.SalesByService,
                    breadcrumb: [{ name: i18nText("Продажи по услугам") }],
                    props: {
                        source: {
                            root: "Report",
                            name: "Report",
                            items: "reports",
                            item: "report",
                            routePage: RouterNameEnum.SalesByServicePage,
                        },
                    },
                },
                name: RouterNameEnum.SalesByServicePage,
                component: (): any => import('../../UI/pages/reports/Pages/SalesByService.vue'),
            },
            {
                path: '/reports/sales_by_clients',
                meta: {
                    breadcrumb: [{ name: i18nText("Продажи по клиентам") }],
                },
                name: RouterNameEnum.SalesByClients,
                component: (): any => import('../../UI/pages/reports/Pages/SalesByClients.vue'),
            },
        ],
    },
];
